import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import {goBack, push} from 'react-router-redux';
import { connect } from 'react-redux';
import isEmpty from 'lodash.isempty';
import lodashIsEqual from 'lodash.isequal';
import { ProjectTaskActionCreators, AppActionCreators } from '../../../../actions';
import { ProjectTaskCard } from './ProjectTaskCard';
import { RouteUrls } from '../../../../configs/routeUrls';
import { isEqual } from 'date-fns';

class ProjectTaskCardContainer extends Component {
	componentDidMount() {
		let { id } = this.props.match.params;
		if (id) {
			this.props.getProjectTask(id);
		}

		if (this.props.projectTask)
			this.props.setBreadcrumbs([
				{
					url: RouteUrls.Budget.list.actual,
					displayName: 'Budżet obywatelski'
				},
				{
					url: RouteUrls.Budget.projectTasks.listForYear(this.props.projectTask.budgetYearId),
					displayName: 'Projekty'
				},
				{
					url: RouteUrls.Budget.projectTasks.previewFunc(this.props.projectTask.id),
					displayName: 'Projekt'
				}
			]);
	}
	componentDidUpdate(prevProps) {
		if (!lodashIsEqual(prevProps.projectTask, this.props.projectTask))
			this.props.setBreadcrumbs([
				{
					url: RouteUrls.Budget.list.actual,
					displayName: 'Budżet obywatelski'
				},
				{
					url: RouteUrls.Budget.projectTasks.listForYear(this.props.projectTask.budgetYearId),
					displayName: 'Projekty'
				},
				{
					url: RouteUrls.Budget.projectTasks.previewFunc(this.props.projectTask.id),
					displayName: 'Projekt'
				}
			]);
	}
	render() {
		let isOnlyOneOffice = this.props;
		const { showBackButton } = this.props;

		return (
			<ProjectTaskCard
				{...this.props.projectTask}
				mapConfig={this.props.mapConfig}
				isProjectTaskLoading={this.props.isProjectTaskLoading}
				onCancel={this.props.cancel}
				isOnlyOneOffice={isOnlyOneOffice}
				showBackButton={showBackButton}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isProjectTaskLoading: state.projectTask.isProjectTaskLoading,
		projectTask: state.projectTask.projectTask,
		mapConfig: state.app.mapConfiguration || {
			zoom: 13,
			latitude: 51.215933,
			longitude: 19.134422
		},
		isOnlyOneOffice: state.app.offices && state.app.offices.length === 1,
		showBackButton: !isEmpty(state.routing.location.prevPathname) && (state.routing.location.prevPathname !== state.routing.location.pathname)
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators({ ...ProjectTaskActionCreators, ...AppActionCreators }, dispatch),
		goTo: (url) => dispatch(push(url)),
		cancel: () => dispatch(goBack())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectTaskCardContainer);
